import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import { ScreenPrompt } from 'components/ScreenPrompt';
import { useDragAndReorder } from 'hooks/useDragAndReorder';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row
} from 'reactstrap';
import { ConfigSurveyQuestion } from '../components/question';
import { ValidateRemiderToSend } from './ValidateRemiderToSend';

const ConfigSurveyFields = ({
  isUpdate,
  isDirty,
  isLoading,
  formData,
  generalConfigs,
  queueOptions,
  questionAudioOptions,
  finalAudioOptions,
  tagOptions,
  handleChange,
  handleQuestionsChange,
  handleAddQuestion,
  handleRemoveQuestion,
  handleUpdateQuestion,
  onSubmit
}) => {
  const history = useHistory();

  const {
    dragOverItem,
    handleDragStart,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDragEnd
  } = useDragAndReorder(
    formData.questions,
    () => {},
    (newOrder) => {
      handleQuestionsChange(newOrder);
    },
    { reorderingMode: 'swap' }
  );

  const reminderToResend = formData.reminderToResend;

  return (
    <>
      <ScreenPrompt
        when={isDirty}
        message={`Está certo de que deseja sair? Terá que preencher os dados novamente quando retornar`}
      />

      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/configSurvey/list"
        buttonTitle="Voltar para a página de configuração de pesquisa"
      />

      <Container className="mt--6" fluid>
        <Row className="mt--3">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">
                    {isUpdate ? 'Editar' : 'Criar'} Configuração de Pesquisa
                  </h3>
                </CardHeader>

                <CardBody>
                  <form onSubmit={onSubmit}>
                    <h4 className="mb-2">Informações Básicas</h4>
                    <Row>
                      <Col md="6">
                        <FormGroup className="my-0">
                          <Label>Nome da pesquisa</Label>
                          <Input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={(e) =>
                              handleChange('name', e.target.value)
                            }
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="my-0">
                          <Label>Fila(s) associada(s)</Label>
                          <Select
                            noOptionsMessage={() =>
                              'Nenhuma opção disponível...'
                            }
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                minHeight: '46px'
                              })
                            }}
                            placeholder="Selecione"
                            isMulti
                            name="queues"
                            options={queueOptions}
                            value={formData.queues}
                            onChange={(value) => handleChange('queues', value)}
                            classNamePrefix="react-select"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <hr />

                    <h4 className="mb-2 mt-2">Mensagens de Interação</h4>
                    <Row>
                      <Col md="6">
                        <FormGroup className="my-0">
                          <Label>Mensagem inicial</Label>
                          <Input
                            type="textarea"
                            name="initialMessage"
                            value={formData.initialMessage}
                            onChange={(e) =>
                              handleChange('initialMessage', e.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="my-0">
                          <Label>Mensagem de encerramento</Label>
                          <Input
                            type="textarea"
                            name="finalMessage"
                            value={formData.finalMessage}
                            onChange={(e) =>
                              handleChange('finalMessage', e.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col md="6">
                        <FormGroup className="my-0">
                          <Label>Quantidade máxima de tentativas</Label>
                          <Input
                            type="number"
                            name="quantityOfInvalidAttempts"
                            min={0}
                            value={formData.quantityOfInvalidAttempts}
                            onChange={(e) =>
                              handleChange(
                                'quantityOfInvalidAttempts',
                                e.target.value
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="my-0">
                          <Label>Mensagem de resposta inválida</Label>
                          <Input
                            type="text"
                            name="incorrectOptionMessage"
                            value={formData.incorrectOptionMessage}
                            onChange={(e) =>
                              handleChange(
                                'incorrectOptionMessage',
                                e.target.value
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <hr />

                    <h4 className="mb-2 mt-2">Configuração de Áudios</h4>
                    <Row>
                      <Col md="6">
                        <FormGroup className="my-0">
                          <Label>Áudio inicial</Label>
                          <Select
                            noOptionsMessage={() =>
                              'Nenhuma opção disponível...'
                            }
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                minHeight: '46px'
                              })
                            }}
                            placeholder="Selecione"
                            name="initialAudioId"
                            options={questionAudioOptions}
                            value={formData.initialAudioId}
                            onChange={(value) =>
                              handleChange('initialAudioId', value)
                            }
                            classNamePrefix="react-select"
                            isClearable
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="my-0">
                          <Label>Áudio de encerramento</Label>
                          <Select
                            noOptionsMessage={() =>
                              'Nenhuma opção disponível...'
                            }
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                minHeight: '46px'
                              })
                            }}
                            placeholder="Selecione"
                            name="finalAudioId"
                            options={finalAudioOptions}
                            value={formData.finalAudioId}
                            onChange={(value) =>
                              handleChange('finalAudioId', value)
                            }
                            classNamePrefix="react-select"
                            isClearable
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <hr />

                    <h4 className="mb-2 mt-2">Preferências de Envio</h4>
                    <Row className="px-4">
                      <Col md="12">
                        <FormGroup check className="mb-2">
                          <Label check>
                            <Input
                              type="checkbox"
                              name="sendToActiveContact"
                              checked={formData.sendToActiveContact}
                              onChange={(e) =>
                                handleChange(
                                  'sendToActiveContact',
                                  e.target.checked
                                )
                              }
                            />
                            Enviar pesquisa para contato ativo
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              name="reminderToResend"
                              checked={formData.reminderToResend}
                              onChange={(e) =>
                                handleChange(
                                  'reminderToResend',
                                  e.target.checked
                                )
                              }
                            />
                            Relembrar pesquisa no chat
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>

                    {reminderToResend && (
                      <Row className="mt-3 px-4">
                        <Col md="4">
                          <FormGroup className="my-0">
                            <Label>Mensagem de Lembrete</Label>
                            <Input
                              type="textarea"
                              name="reminderMessage"
                              value={formData.reminderMessage}
                              onChange={(e) =>
                                handleChange('reminderMessage', e.target.value)
                              }
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="my-0">
                            <Label>Tentativas de Lembrete</Label>
                            <Input
                              type="number"
                              name="reminderAttempts"
                              min={0}
                              value={formData.reminderAttempts}
                              onChange={(e) =>
                                handleChange('reminderAttempts', e.target.value)
                              }
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="my-0">
                            <Label>Tempo para Lembrete (minutos)</Label>
                            <Input
                              type="number"
                              name="reminderTime"
                              min={0}
                              value={formData.reminderTime}
                              onChange={(e) =>
                                handleChange('reminderTime', e.target.value)
                              }
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col className="mt-2">
                          <ValidateRemiderToSend
                            min={
                              formData.reminderTime &&
                              formData.reminderAttempts &&
                              formData.reminderTime * formData.reminderAttempts
                            }
                            max={generalConfigs?.tempoDeEsperaDeResposta ?? 0}
                            totalTimeLimitSurvey={
                              generalConfigs?.tempoDeEsperaDeResposta ?? 0
                            }
                          />
                        </Col>
                      </Row>
                    )}

                    <hr />

                    <Row className="px-3">
                      <h4 className="mb-2 mt-2">Perguntas da Pesquisa</h4>
                      {formData.questions?.map?.((field, index) => (
                        <div
                          key={field.id || index}
                          className="mt-2"
                          style={{ width: '100%', position: 'relative' }}
                        >
                          {dragOverItem.current === index && (
                            <div
                              style={{
                                height: '4px',
                                width: '100%',
                                backgroundColor: '#6772e5',
                                borderRadius: '2px',
                                margin: '-8px 0 8px 0'
                              }}
                            />
                          )}

                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: '8px'
                            }}
                          >
                            <div
                              draggable
                              onDragStart={(e) => handleDragStart(e, index)}
                              onDragEnter={(e) => handleDragEnter(e, index)}
                              onDragLeave={(e) => handleDragLeave(e)}
                              onDragOver={(e) => handleDragOver(e)}
                              onDragEnd={handleDragEnd}
                              style={{
                                cursor: 'grab',
                                padding: '6px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#6c757d',
                                marginBlock: 'auto',
                                height: '100%'
                              }}
                              title="Arraste para reordenar"
                            >
                              <DragIndicatorIcon />
                            </div>

                            <div style={{ flex: 1 }}>
                              <ConfigSurveyQuestion
                                {...{
                                  questionData: field,
                                  index,
                                  allQuestions: formData.questions,
                                  handleUpdateQuestion,
                                  handleRemoveQuestion,
                                  handleQuestionsChange,
                                  questionAudioOptions,
                                  tagOptions
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </Row>
                    <Row>
                      <Col md="auto" className="mx-auto mt-4">
                        <Button
                          color="primary"
                          type="button"
                          onClick={handleAddQuestion}
                        >
                          Adicionar Pergunta
                        </Button>
                      </Col>
                    </Row>
                    <Row className="align-items-center mt-2">
                      <Col>
                        <Button
                          color="secondary"
                          type="button"
                          onClick={() =>
                            history.push('/admin/configSurvey/list')
                          }
                        >
                          Cancelar
                        </Button>
                        <Button
                          color="success"
                          type="submit"
                          className="float-right"
                          disabled={isLoading}
                        >
                          {isLoading
                            ? 'Carregando...'
                            : isUpdate
                            ? 'Atualizar'
                            : 'Criar'}
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ConfigSurveyFields;
